import React, { useEffect, useState } from "react";
import api from "../services/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../styles/floatingForm.css";

/* IMAGE BASE URL */

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL.endsWith("/")
  ? process.env.REACT_APP_IMAGE_BASE_URL
  : process.env.REACT_APP_IMAGE_BASE_URL + "/";

const ManageBlog = () => {

  const navigate = useNavigate();

  const { id } = useParams();

  // undefined when creating
  // actual ID when editing
  const editId = id;

  const [form, setForm] = useState({
    blogname: "",
    blogurl: "",
    blogtext: "",
    blogshortimagealt: "",
    blogbanneralt: "",
  });

  const [shortImage, setShortImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);

  const [existingShortImage, setExistingShortImage] = useState("");
  const [existingBannerImage, setExistingBannerImage] = useState("");

  /* ---------------- FETCH BLOG ---------------- */

  const fetchBlog = async () => {

    try {

      const res = await api.get("/Blog/get-all");

      if (res.data.status === "success") {

        const blog = res.data.data.find(
          (b) => String(b.id) === String(editId)
        );

        if (!blog) {

          toast.error("Blog not found");

          navigate("/blog");

          return;
        }

        setForm({
          blogname: blog.blogname || "",
          blogurl: blog.blogurl || "",
          blogtext: blog.blogtext || "",
          blogshortimagealt:
            blog.blogshortimagealt || "",
          blogbanneralt:
            blog.blogbanneralt || "",
        });

        setExistingShortImage(
          blog.blogshortimg || ""
        );

        setExistingBannerImage(
          blog.blognanner || ""
        );
      }

    } catch (error) {

      console.error(error);

      toast.error("Failed to fetch blog");

    }

  };

  useEffect(() => {

    if (editId) {
      fetchBlog();
    }

  }, [editId]);

  /* ---------------- SUBMIT ---------------- */

  const handleSubmit = async (e) => {

    e.preventDefault();

    const formData = new FormData();

    formData.append(
      "blogname",
      form.blogname
    );

    formData.append(
      "blogurl",
      form.blogurl
    );

    formData.append(
      "blogtext",
      form.blogtext
    );

    formData.append(
      "blogshortimagealt",
      form.blogshortimagealt
    );

    formData.append(
      "blogbanneralt",
      form.blogbanneralt
    );

    if (shortImage) {

      formData.append(
        "logo_image_path",
        shortImage
      );

    }

    if (bannerImage) {

      formData.append(
        "banner_image_path",
        bannerImage
      );

    }

    try {

      const res = editId

        ? await api.post(
            `/blog/update/${editId}`,
            formData,
            {
              headers: {
                "Content-Type":
                  "multipart/form-data",
              },
            }
          )

        : await api.post(
            `/blog/add`,
            formData,
            {
              headers: {
                "Content-Type":
                  "multipart/form-data",
              },
            }
          );

      if (res.data.status === "success") {

        toast.success(
          editId
            ? "Blog updated"
            : "Blog created"
        );

        navigate("/blog");

      }

    } catch (err) {

      toast.error("Server error");

      console.error(err);

    }

  };

  /* ---------------- CANCEL / BACK ---------------- */

  const closeForm = () => {

    navigate("/blog");

  };

  return (
    <div className="floating-form-container" >
      <div className="heading">
        <h2>{editId ? "Update Blog" : "Create Blog"}</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">

          <div className="section-1">
            <div className="input-container-floating-form wid-100">
              <label htmlFor="name">Blog Tiltle </label>
                <input
                  type="text"
                  placeholder="Blog Name"
                  value={form.blogname}
                  onChange={(e) =>
                    setForm({ ...form, blogname: e.target.value })
                  }
                />
            </div>

            <div className="input-container-floating-form wid-100">
              <label htmlFor="name">URl Name</label>
                <input
                  type="text"
                  placeholder="Blog URL"
                  value={form.blogurl}
                  onChange={(e) =>
                    setForm({ ...form, blogurl: e.target.value })
                  }
                />
            </div>

          </div>
      
          <div className="section-1">
            <div className="input-container-floating-form wid-100">
              <label htmlFor="aboutUs">Blog Description</label>
              <ReactQuill
                value={form.blogtext}
                onChange={(v) => setForm({ ...form, blogtext: v })}
              />

            </div>
          </div>

          {/* Short Image */}
          <div className="section-1 mt-5">
            <h2 className='wid-100'>Upload Image</h2>
              <div className="input-container-floating-form wid-50">
                  <label htmlFor="logo">Blog Short Image * <br /> (size 350px*350px)</label>
                  
                  <input
                    type="file"
                      accept="image/png,image/jpeg,image/jpg,image/webp,.webp"
                    onChange={(e) => setShortImage(e.target.files[0])}
                  />
                  {existingShortImage && !shortImage && (
                    <img
                      src={`${IMAGE_BASE_URL}${existingShortImage}`}
                      alt="short"
                      style={{ maxWidth: 200, marginTop: 10 }}
                    />
                  )}

                 <div className="input-container-floating-form wid-100">
                    <label>Short Image Alt</label>
                    <input
                      type="text"
                      placeholder="Enter short image alt text"
                      value={form.blogshortimagealt}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          blogshortimagealt: e.target.value,
                        })
                      }
                    />
                  </div> 
            </div>

              {/* Banner Image */}
                

                        
                <div className="input-container-floating-form wid-50">
                  <label htmlFor="logo">Blog Banner <br /> (size 950px*496px)</label>
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/jpg,image/webp,.webp"
                    onChange={(e) => setBannerImage(e.target.files[0])}
                  />
                  {existingBannerImage && !bannerImage && (
                    <img
                      src={`${IMAGE_BASE_URL}${existingBannerImage}`}
                      alt="banner"
                      style={{ maxWidth: 200, marginTop: 10 }}
                    />
                  )}

                  <div className="input-container-floating-form wid-100">
                    <label>Banner Image Alt</label>
                    <input
                      type="text"
                      placeholder="Enter banner image alt text"
                      value={form.blogbanneralt}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          blogbanneralt: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
          </div>
        </div>

        <div className="form-btn-container">
          <button type="submit">{editId ? "Update" : "Create"}</button>
          <button type="reset" onClick={closeForm}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default ManageBlog;
